
export type RolesType = {
    acts: {
        access: boolean,
        view: {
            access: boolean
        },
        download: {
            access: boolean
        },
        detailing: {
            access: boolean
        },
    }
    analytics: {
        access: boolean
        consumptions: {
            access: boolean
        },
        price_comparison: {
            access: boolean
        },
        saldo: {
            access: boolean
        },
        view: {
            access: boolean
        },
        change: {
            access: boolean
        },
    }
    balances: {
        access: boolean,
        view: {
            access: boolean
        },
        download: {
            access: boolean
        },
    }
    consumptions: {
        access: boolean,
        view: {
            access: boolean
        },
        create: {
            access: boolean
        },
    }
    contract: {
        access: boolean
        contact: {
            access: boolean
        },
        files: {
            access: boolean
        },
        info: {
            access: boolean
        }
        payment: {
            access: boolean
        }
        points: {
            access: boolean
        }
        requsite: {
            access: boolean
        }
        view: {
            access: boolean
        }
    }
    invoices: {
        access: boolean,
        view: {
            access: boolean
        }
        download: {
            access: boolean
        }
    }
    payments: {
        access: boolean,
        view: {
            access: boolean
        }
    }
    profile: {
        access: boolean,
        view: {
            access: boolean
        }
        request: {
            access: boolean
        }
    }
}
export const DEFAULT_ROLES = {
    acts: {
        access: false,
        view: {
            access: false
        },
        download: {
            access: false
        },
        download_invoice: {
            access: false
        },
        detailing: {
            access: false
        },
    },
    analytics: {
        access: false,
        consumptions: {
            access: false
        },
        price_comparison: {
            access: false
        },
        saldo: {
            access: false
        },
        view: {
            access: false
        },
        change: {
            access: false
        },
    },
    balances: {
        access: false,
        view: {
            access: false
        },
        download: {
            access: false
        },
    },
    consumptions: {
        access: false,
        view: {
            access: false
        },
        create: {
            access: false
        },
    },
    contract: {
        access: false,
        contact: {
            access: false
        },
        files: {
            access: false
        },
        info: {
            access: false
        },
        payment: {
            access: false
        },
        points: {
            access: false
        },
        requsite: {
            access: false
        },
        view: {
            access: false
        }
    },
    invoices: {
        access: false,
        view: {
            access: false
        },
        download: {
            access: false
        }
    },
    payments: {
        access: false,
        view: {
            access: false
        }
    },
    profile: {
        access: false,
        view: {
            access: false
        },
        request: {
            access: false
        }
    }
}

// ====
// type AccessNode = {
//     access: boolean;
//     [key: string]: AccessNode | boolean;
// };

// export type RolesType = {
//     acts: AccessNode;
//     analytics: AccessNode;
//     balances: AccessNode;
//     consumptions: AccessNode;
//     contract: AccessNode;
//     invoices: AccessNode;
//     payments: AccessNode;
//     profile: AccessNode;
// };
 
function isRoleKey(key: string, roles: RolesType): key is keyof RolesType {
    if (!roles) return false
    return key in roles;
}
export function hasRoleAccess(
    path: string,
    roles: RolesType | null | undefined
): boolean {
    if (!roles) return false;

    const keys = path.split('.');
    const rootKey = keys[0];

    // проверяем корневой ключ 
    if (!isRoleKey(rootKey, roles)) return false;

    let current: any = roles[rootKey];

    // если путь без вложенности — сразу access
    if (keys.length === 1) {
        return Boolean(current?.access);
    }

    // идём по вложенным ключам
    for (let i = 1; i < keys.length; i++) {
        const key = keys[i];

        if (
            typeof current !== 'object' ||
            current === null ||
            !Object.prototype.hasOwnProperty.call(current, key)
        ) {
            return false;
        }

        current = current[key];
    }

    // return false
    return Boolean(current?.access);
}

// export function hasRoleAccess(
//     key: string,
//     roles: RolesType | null | undefined
// ): boolean {
//     return Boolean(
//         roles &&
//         isRoleKey(key, roles) &&
//         roles[key].access
//     );
// }